export default __webpack_public_path__ + "static/media/code4.d812cd65.png";